import React, { useContext, useEffect } from 'react';
import { FormContext } from 'contexts/FormContext';
import { useFormikContext } from 'formik';
import { get } from 'lodash';
import { ApplicationName } from 'components/CASAForm';
import {
  AuTextInput,
  AuDateInput,
  AuControlInput,
  AuCallout,
  AuFormItemWrapper,
  AuDirectionLink,
  AuErrorText
} from 'components/DTA';

const AustralianCitizenshipCertificateDetails: React.FC = () => {
  const { handleBack, setFormAlert, openStepById } = useContext(FormContext);
  const { errors, setFieldValue, getFieldMeta } = useFormikContext();
  const declarationFieldError = get(errors, 'auCitizenshipCertificateDetails.declaration');

  useEffect(() => {
    setFieldValue('auCitizenshipCertificateDetails.isManualUpload', false);
  }, []);

  const dvsValidationIndicator = getFieldMeta('auCitizenshipCertificateDetails.dvsValidationIndicator').value;
  const isLocked = dvsValidationIndicator === 'Passed';
  const handleBackToIdentitySelection = () => {
    setFormAlert(null);
    openStepById('IdentityVerification');
  };
  return (
    <>
      <ApplicationName name='Australian citizenship certificate details' />
      <AuDirectionLink
        onClick={handleBackToIdentitySelection}
        text="Back"
        direction="left" />
      <AuTextInput
        name='auCitizenshipCertificateDetails.familyName'
        label='Family name'
        hintText='Please enter your family name (surname) as written on your citizenship certificate'
        as='input'
        block
        disabled={isLocked} />
      <AuTextInput
        name='auCitizenshipCertificateDetails.givenNames'
        label='Given names'
        hintText='Please enter all given names as written on your citizenship certificate, including any middle names'
        as='input'
        block
        disabled={isLocked} />
      <AuDateInput
        name='auCitizenshipCertificateDetails.dateOfBirth'
        label='Date of birth'
        hintText='For example, 31 01 1990'
        disabled={isLocked} />
      <AuDateInput
        name='auCitizenshipCertificateDetails.acquisitionDate'
        label='Acquisition date'
        disabled={isLocked}
        hintText='The date you acquired your citizenship. For example, 28 02 2000' />
      <AuTextInput
        name='auCitizenshipCertificateDetails.certificateNumber'
        label='Certificate number'
        hintText='This will usually appear on the bottom left of your citizenship certificate, as either "Evidence No." or "No.". This number may also appear on the back of older citizenship certificate.'
        as='input'
        block
        disabled={isLocked} />
      <AuFormItemWrapper>
        <AuCallout title='' style={{ paddingTop: '0' }}>
          <AuControlInput
            name='auCitizenshipCertificateDetails.declaration'
            id='checkbox-auCitizenshipCertificateDetails-declaration'
            label=''
            type='checkbox'
            disabled={isLocked}
            hintText='I confirm that I am authorised to provide the personal details presented and I consent to my information being checked with the document issuer or official record holder via third party systems for the purpose of confirming your identity'
          />
          {declarationFieldError && <AuErrorText text={declarationFieldError} />}
        </AuCallout>
      </AuFormItemWrapper>
    </>
  );
};

export default AustralianCitizenshipCertificateDetails;